<template>
  <!-- Side Nav START -->
  <div class="side-nav">
    <div class="side-nav-inner">
      <ul class="side-nav-menu scrollable mt-1">
        <li class="nav-item dropdown open">
          <router-link class="dropdown-toggle" :to="`/`">
            <span class="icon-holder">
              <i class="fa fa-home" aria-hidden="true"></i>
            </span>
            <span class="title">Dashboard</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/admins`">
            <span class="icon-holder">
              <i class="fa fa-user"></i>
            </span>
            <span class="title">Admins</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/users`">
            <span class="icon-holder">
              <i class="fa fa-users"></i>
            </span>
            <span class="title">Users</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/blogs`">
            <span class="icon-holder">
              <i class="fa fa-files-o"></i>
            </span>
            <span class="title">Blogs</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/homepage-banners`">
            <span class="icon-holder">
              <i class="fa fa-picture-o"></i>
            </span>
            <span class="title">Homepage Banners</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/youtube-banners`">
            <span class="icon-holder">
              <i class="fab fa-youtube"></i>
            </span>
            <span class="title">Youtube Banners</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/youtube-music`">
            <span class="icon-holder">
              <i class="fa fa-music"></i>
            </span>
            <span class="title">Youtube Music</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/releases`">
            <span class="icon-holder">
              <i class="fas fa-compact-disc"></i>
            </span>
            <span class="title">Release Page</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/queries`">
            <span class="icon-holder">
              <i class="fas fa-question-circle"></i>
            </span>
            <span class="title">Contact Queries</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/submissions`">
            <span class="icon-holder">
              <i class="fa fa-paper-plane"></i>
            </span>
            <span class="title">Submissions</span>
          </router-link>
        </li>
        <li class="nav-item dropdown open">
          <router-link :to="`/newsletters`">
            <span class="icon-holder">
              <i class="fas fa-newspaper-o"></i>
            </span>
            <span class="title">Newsletters</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
  <!-- Side Nav END -->
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
    return {}
  },
  mounted () {
    /* eslint-disable no-undef */
    const appLayout = $('#app')
    $('.side-nav-inner .side-nav-menu .nav-item').on('click', () => {
      appLayout.removeClass('is-expand')
    })
  },
  methods: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue